<template>
  <div class="my-card">
    <div class="my-card-title" >
      <slot name="icon">
        <div class="my-card-title-line"></div>
      </slot>
      <slot name="title">
        <div class="my-card-title-label"v-text="title"></div>
      </slot>
    </div>
    <div class="my-card-content"><slot/></div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '标题'
    },
  },
  computed: {},

  data() {
    return {};
  },
  mounted() {

  },

  watch: {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.my-card{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .my-card-title{
    display: flex;
    align-items: center;
    .my-card-title-line{
      width: 2px;
      height: 14px;
      background: #386BFF;
      //background: #920783;
      margin-right: 8px;
    }
    .my-card-title-label{
      height: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  }
  .my-card-content{
    flex:1;
    heigth:100px;
    width:100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyCard.vue